var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.inventory
    ? _c(
        "div",
        [
          _vm.loading
            ? _c("CenterOnParent", [_c("Spinner")], 1)
            : _c(
                "div",
                _vm._l(_vm.binsForDisplay, function(display) {
                  return _c("BinEntry", {
                    key: display.mapping.id,
                    attrs: {
                      inventory: _vm.inventory,
                      mapping: display.mapping,
                      bin: display.bin
                    }
                  })
                }),
                1
              )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }